<script lang="ts">
    import {Component, Prop, toNative, Vue} from 'vue-facing-decorator'
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'

    @Component({mixins: [Breadcrumbs]})
    export class CruisesBreadcrumbs extends Vue {
        @Prop({required: true}) searchRequest
        @Prop({default: () => {}}) product

        get items() {
            const getSearchPageLabel = () => {
                const departure = cruisesRuntimeStore.departureCity?.name || cruisesRuntimeStore.departureCountry?.name
                const destination =
                    cruisesRuntimeStore.destinationCity?.name || cruisesRuntimeStore.destinationCountry?.name

                return departure ? `${departure} - ${destination}` : ` ${destination}`
            }

            const addSearchPageLink = items => {
                    items.push({
                        title: getSearchPageLabel(),
                        to: cruisesRuntimeStore.searchPageLink(this.searchRequest),
                        exact: true,
                    })
                },
                addInfoPageLink = items => {
                    items.push({
                        title: this.product.name,
                        to: cruisesRuntimeStore.infoPageLink(this.product, this.searchRequest),
                        exact: true,
                    })
                }
            const name = useRoute().name
            const items = [this.homeItem]
            switch (name) {
                case 'cruises':
                    items.push({
                        title: getSearchPageLabel(),
                        disabled: true,
                    })
                    break
                case 'cruise':
                    addSearchPageLink(items)
                    items.push({
                        title: this.product.name,
                        disabled: true,
                    })
                    break
                case 'cruiseBooking':
                    addSearchPageLink(items)
                    addInfoPageLink(items)
                    items.push({
                        title: this.$t('reservation'),
                        disabled: true,
                    })
                    break
                case 'cruiseConfirmation':
                    addSearchPageLink(items)
                    items.push({
                        title: this.product.name,
                        disabled: true,
                    })
                    items.push({
                        title: this.$t('confirmation'),
                        disabled: true,
                    })
                    break
            }
            return items
        }
    }

    export default {...toNative(CruisesBreadcrumbs), ssrRender: Breadcrumbs.ssrRender}
</script>
